
export const DOCGEN_ENDPOINTS = {
  READ_PDF: 'read/',
  READ_STREAM: 'read-stream/',
  READ_BASE64: 'read-base64/',
  READ_BASE64_PDF: 'read-base64-pdf/',
};
